import action from '../../../abstract/action.js';
import ZusDeclarationApi from '../../../../../api-v2/bookkeeping/zus-declaration';

export default action({
  label: 'Pobierz',
  icon: 'PrinterIcon',
  main: () => false,
  handle: async ({reloadList, $vs, item}) => {
    $vs.loading();

    ZusDeclarationApi.printPdf({ declarationId: item.id })
      .then(({ data: { url } }) => {
        const link = document.createElement('a');
        link.download = 'download';
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .finally(() => {
        $vs.loading.close();
      });
  },
});
